import { useEffect, useState } from 'react';
import intl from 'react-intl-universal';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@getsynapse/design-system';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { isUserOrganizationAdmin, selectIsUserLd } from 'state/User/userSlice';
import { fetchPrograms, programsFilters } from 'state/Programs/programsSlice';
import { PATHS } from 'utils/constants';
import { PROGRAM_TABLE_FILTERS } from 'utils/constants/program';
import PageTitle from 'Molecules/PageTitle/PageTitle';
import AddProgramModal from './components/AddProgramModal';
import ProgramsList from './components/ProgramsList';

const ProgramsListPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isUserAdmin = useSelector(isUserOrganizationAdmin);
  const isUserLd = useSelector(selectIsUserLd);
  const filters = useSelector(programsFilters);
  const dispatch = useDispatch();
  const history = useHistory();
  const { archivePrograms = false } = useFlags();
  const includeArchived =
    archivePrograms && Boolean(filters[PROGRAM_TABLE_FILTERS.ARCHIVED]);

  useEffect(() => {
    if (!isUserAdmin && !isUserLd) {
      history.push(PATHS.ROOT);
    }
    dispatch(fetchPrograms(includeArchived));
  }, [dispatch, isUserAdmin, isUserLd, history, includeArchived]);

  return (
    <>
      <AddProgramModal setIsOpen={setIsModalOpen} isOpen={isModalOpen} />
      <PageTitle
        titleComponent={intl.get('PROGRAMS_LIST_PAGE.TITLE')}
        headerChildren={
          <Button
            onClick={() => setIsModalOpen(true)}
            data-testid='add-program_button'
          >
            {intl.get('PROGRAMS_LIST_PAGE.ADD_PROGRAM_BUTTON')}
          </Button>
        }
      />
      <ProgramsList onAddProgram={() => setIsModalOpen(true)} />
    </>
  );
};

export default ProgramsListPage;
